import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { RootState } from "@/store/modules/general/types";
import { API_PEDIDO } from './types';



const namespaced = true;

type FinalizarPedidoModule = Module<API_PEDIDO, RootState>;

export const FinalizarPedido: FinalizarPedidoModule = {
    namespaced,
    actions,
    getters,
    mutations,
}